/**
 * List Schema of Cargo
 * @author Thacryba
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Cargo} from '@/model/resource/Cargo'

export class ListCargoSchema extends Schema {
  readonly name = 'ListCargo'

  readonly fieldSet: FieldSet<Cargo> = {
    idCargoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    document: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.document,
      },
    }),
    emissionDate: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.emissionDate),
      },
    }),
    deliveryDate: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.deliveryDate),
      },
    }),
    systemDeliveryDate: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.systemDeliveryDate),
      },
    }),
    creationDate: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.creationDate),
      },
    }),
    expectedDate: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.expectedDate),
      },
    }),
    active: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.active),
      },
    }),
    note: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.note,
      },
    }),
    idCreatorSystemFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.creatorSystem?.$id,
      },
    }),
    idFinisherSystemFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.finisherSystem?.$id,
      },
    }),
    idCargoStatusFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.cargoStatus?.$id,
      },
    }),
    idTransporterFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.transporter?.$id,
      },
    }),
    idShipperFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.shipper?.$id,
      },
    }),
    idPanelUserCreatorFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.creator?.$id,
      },
    }),
    idDriverFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.driver?.$id,
      },
    }),
    idReceptorFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.receptor?.$id,
      },
    }),
    dte: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.dte,
      },
    }),
    idAddressFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.address?.$id,
      },
    }),
    idOccurrenceFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.occurrence?.$id,
      },
    }),
    idDocumentPhotoFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.idDocumentPhotoFk,
      },
    }),
    returned: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.returned),
      },
    }),
    idVisualizationModeFk: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.visualizationMode?.$id,
      },
    }),
  }
}
